export default (function (value) {
  return value.toString();
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/toString.js
// module id = 865
// module chunks = 0